import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AccountNotificationsEffects } from './store/accounts-notifications.effects';
import { accountNotificationReducer } from './store/accounts-notifications.reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    EffectsModule.forFeature([AccountNotificationsEffects]),
    StoreModule.forFeature('accountsNotification', accountNotificationReducer),
  ],
})
export class AccountsNotificationsModule {}
